import { ReactElement } from 'react';
import { Button } from '@mui/material';

import { Dialog } from '../components';
import { useOpenReLoginDialog } from '../services/store/OpenReLoginDialog';
import { translate } from '../utils/translations';
import { PAGE_PATH } from '../constants';

function ReloadButton(): ReactElement {
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => {
        window.location.replace(PAGE_PATH.LOGOUT);
      }}
    >
      {translate('COMMON.CLOSE')}
    </Button>
  );
}

/**
 * 他のタブでログアウトした時、セッションが切れた時に出るダイアログ
 */
export function ReLoginDialog() {
  const { open } = useOpenReLoginDialog();

  return (
    <Dialog
      actions={[<ReloadButton key={1} />]}
      title={translate('RELOGIN_DIALOG.TITLE')}
      content={translate('RELOGIN_DIALOG.MESSAGE')}
      open={open}
      onClose={() => {}}
      width={540}
    />
  );
}
